<template>
    <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :title="title" :size="'md'" :centered="true" :btn_cancel="true"
        :btn_ok="true" :booTitile="true">
        <div class="container">
            <CRow>
                <CCol>
                    <CTextarea label="Descripción del servicio" placeholder="Ingrese la descripción..." rows="9"
                        v-model="dataPost.detail_service" />
                </CCol>
            </CRow>
        </div>
        <template #footer>
            <CButton class="btn-secondary" @click="mtdClose" :style="{ color: 'black' }">
                <i class="fa fa-times"></i>&nbsp;Cerrar
            </CButton>
            <CButton @click="saveDescription" class="btn-info">
                <i class="fa fa-save"></i>&nbsp;Guardar
            </CButton>
        </template>
    </CModal>
</template>
<script>
import CModal from "../../shared/modals/cModalFormCom.vue";
import { mapActions } from "vuex";

export default {
    name: "c-addDescription-modal",
    components: {
        CModal,
    },
    data() {
        return {
            swal: null,
            dataPost: {
                detail_service: "",
            },
        }
    },
    props: {
        title: String,
        boo_modal: Boolean,
        id_reserva: Number,
        item: Object
    },
    watch: {
        boo_modal(newVal) {
            if (newVal) {
                this.dataPost.detail_service = this.item.detail_service;
            }
        },
    },
    methods: {
        ...mapActions(["get", "post"]),
        mtdClose() {
            this.$emit("closeModalDescriptionAnterior");
        },
        saveDescription: function () {
            this.post({
                url: this.$store.getters.get__url + "/cita/addDescription/" + this.$store.getters.get_company.id + "/" + this.$store.getters.get_campu.id,
                token: this.$store.getters.get__token,
                params: {
                    id: this.id_reserva,
                    dataPost: this.dataPost.detail_service,
                }
            }).then((response) => {
                if (response.statusCode == 200) {
                    Swal.fire({
                        title: "Descripción agregada correctamente",
                        icon: "success",
                    })
                    this.mtdClose();
                }

            });
        },
    }
}
</script>